var PartnerServicesEnum = /* @__PURE__ */ ((PartnerServicesEnum2) => {
  PartnerServicesEnum2["PARTNER_SERVICES_IN_PERSON_SEE_MORE"] = "partner-services-in-person--see-more";
  PartnerServicesEnum2["PARTNER_SERVICES_TELEHEALTH_SEE_MORE"] = "partner-services-telehealth--see-more";
  PartnerServicesEnum2["PARTNER_SERVICES_PRICE_MODAL"] = "partner-services-price-modal";
  PartnerServicesEnum2["PARTNER_SERVICES_SLOTS_MODAL"] = "partner-services-slots-modal";
  return PartnerServicesEnum2;
})(PartnerServicesEnum || {});
export {
  PartnerServicesEnum
};
